"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = require("lodash");
var _state = _interopRequireDefault(require("@/libs/state"));
var EmojiProvider = _interopRequireWildcard(require("@/libs/EmojiProvider"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = render;
function render(blocks, renderEmoticons) {
  const state = (0, _state.default)();
  const showEmoticons = typeof renderEmoticons === 'undefined' ? state.setting('buffers.show_emoticons') : !!renderEmoticons;
  // Couleurs mIRC (\x03) désactivées par défaut ; activables via le réglage.
  const showColors = state.setting('buffers.show_message_colors');
  const retHtml = blocks.reduce((html, block, i) => {
    // a
    let style = '';
    let classes = '';
    Object.keys(block.styles).forEach(s => {
      if (s === 'underline') {
        style += 'text-decoration:underline;';
      } else if (s === 'bold') {
        style += 'font-weight:bold;';
      } else if (s === 'italic') {
        style += 'font-style:italic;';
      } else if (s === 'quote') {
        classes += 'app-formatting-extras-quote ';
      } else if (s === 'block') {
        classes += 'app-formatting-extras-block ';
      } else if (s === 'color') {
        if (showColors) {
          classes += `irc-fg-colour-${block.styles[s]} `;
        }
      } else if (s === 'background') {
        if (showColors) {
          classes += `irc-bg-colour-${block.styles[s]} `;
        }
      }
    });
    let content;
    switch (block.type) {
      case 'url':
        content = linkifyUrl(block, {
          addHandle: state.setting('buffers.show_link_previews'),
          handleClass: 'fa fa-share-square u-link app-messagelist-message-linkhandle'
        });
        break;
      case 'user':
        content = linkifyUser(block);
        break;
      case 'channel':
        content = linkifyChannel(block);
        break;
      case 'emoji':
        content = EmojiProvider.blockToHtml(block, blocks.length === 1, showEmoticons);
        break;
      default:
        content = (0, _lodash.escape)(block.content);
    }
    return html + buildSpan(content, classes, style);
  }, '');
  return `${retHtml}`;
}
function linkifyUrl(block, _opts) {
  let opts = _opts || {};
  let nice = '';

  // Shorten the displayed URL if it's going to be too long
  if (block.content.length > 100) {
    nice = (0, _lodash.escape)(block.content.substr(0, 100)) + '...';
  } else {
    nice = (0, _lodash.escape)(block.content);
  }

  // Make the link clickable
  let href = block.meta.url.replace(/"/g, '%22');
  let out = `<a target="_blank" href="${href}" rel="noopener noreferrer" class="u-link">${nice}</a>`;
  if (opts.addHandle) {
    let cssClass = opts.handleClass || '';
    let content = opts.handleContent || '';
    out += `<a data-url="${(0, _lodash.escape)(block.meta.url)}" class="${cssClass}">${content}</a>`;
  }
  return out;
}
function linkifyUser(block) {
  let escaped = (0, _lodash.escape)(block.meta.user);
  let colour = block.meta.colour;
  return `<a class="app-nick" data-nick="${escaped}"` + (colour ? ` style="color:${colour};"` : '') + `>${escaped}</a>`;
}
function linkifyChannel(block) {
  return `<a class="u-link app-channel" data-channel-name="${(0, _lodash.escape)(block.meta.channel)}">${(0, _lodash.escape)(block.content)}</a>`;
}
function buildSpan(content, classes, style) {
  if (style === '' && classes === '') {
    return content;
  }
  return '<span' + (style !== '' ? ` style="${style}"` : '') + (classes !== '' ? ` class="${classes}"` : '') + `>${content}</span>`;
}
window._app_exports = window._app_exports || {};
if(!window._app_exports["libs"]) window._app_exports["libs"] = {};
if(!window._app_exports["libs"]["renderers"]) window._app_exports["libs"]["renderers"] = {};
window._app_exports["libs"]["renderers"]["Html"]
window._app_exports.libs.renderers.Html = exports.default ? exports.default : exports;
